/*
 *
 * Subscriptions actions
 *
 */

import {
  GET_SUBSCRIPTIONS_ATTEMPT,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_FAILURE,
  SET_SELECTED_SUBSCRIPTION,
  GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT,
  GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT,
  GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT,
  CLEAR_SUBSCRIPTIONS_LIST,
} from './constants';

export function getSubscriptionsAttempt(params, brand, userName, searchBy, token) {
  return {
    type: GET_SUBSCRIPTIONS_ATTEMPT,
    params,
    brand,
    userName,
    searchBy,
    token,
  };
}

export function getSubscriptionsSuccess(subscriptionsList, token) {
  return {
    type: GET_SUBSCRIPTIONS_SUCCESS,
    subscriptionsList,
    token,
  };
}

export function getSubscriptionsFailure(error) {
  return {
    type: GET_SUBSCRIPTIONS_FAILURE,
    error,
  };
}

export function setSelectedSubscription(subscription) {
  return {
    type: SET_SELECTED_SUBSCRIPTION,
    subscription,
  };
}

export function getSubscriptionsAttemptForAccount(params, brand, userName, searchBy, token) {
  return {
    type: GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT,
    params,
    brand,
    userName,
    searchBy,
    token,
    forAccount: true,
  };
}

export function getSubscriptionsFailureForAccount(error) {
  return {
    type: GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT,
    error,
  };
}

export function getSubscriptionsSuccessForAccount(subscriptionsList, token) {
  return {
    type: GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT,
    subscriptionsList,
    token,
  };
}

export function clearSubscriptionsList() {
  return {
    type: CLEAR_SUBSCRIPTIONS_LIST,
  };
}
